import React from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Product from "@/components/Product";
import ScandalCards from "@/components/ScandalCards";
import Gallery from "@/components/Gallery";
import Timeline from "@/components/Timeline";
import MensalaoSection from "@/components/MensalaoSection";
import TriplexSection from "@/components/TriplexSection";
import Sources from "@/components/Sources";
import Testimonials from "@/components/Testimonials";
import LeadCapture from "@/components/LeadCapture";
import Purchase from "@/components/Purchase";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import FloatingBuy from "@/components/FloatingBuy";

export default function Landing() {
  return (
    <div className="relative grain">
      <Nav />
      <Hero />
      <Marquee />
      <Product />
      <ScandalCards />
      <Gallery />
      <Timeline />
      <MensalaoSection />
      <TriplexSection />
      <Sources />
      <Testimonials />
      <LeadCapture />
      <Purchase />
      <FAQ />
      <FinalCTA />
      <Footer />
      <FloatingBuy />
    </div>
  );
}
